var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"cunchu"},[_c('div',{staticClass:"text"},[_c('div',{staticClass:"p"}),_c('div',{staticClass:"h2"},[_vm._v("堆场货物存储量")])]),_c('div',{attrs:{"id":"dom"}})])])
}]

export { render, staticRenderFns }